import { render, staticRenderFns } from "./seckillUpgradePrice.vue?vue&type=template&id=496fbef0&scoped=true&"
import script from "./seckillUpgradePrice.vue?vue&type=script&lang=js&"
export * from "./seckillUpgradePrice.vue?vue&type=script&lang=js&"
import style0 from "./seckillUpgradePrice.vue?vue&type=style&index=0&id=496fbef0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496fbef0",
  null
  
)

export default component.exports